import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "../Reveal";
import { STATS } from "../../data";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative bg-white py-28 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* text */}
          <div className="lg:col-span-6">
            <Reveal>
              <Overline>About BioSoma</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-zinc-900 mt-6 leading-tight">
                We treat the cause, not the symptom.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="font-body text-base lg:text-lg leading-relaxed text-zinc-600 mt-8 max-w-lg">
                Founded by a team of geneticists, engineers and clinicians, BioSoma
                exists to make genetic medicine programmable, scalable and accessible.
                Our integrated platform compresses the distance between a biological
                insight and a working therapy.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="font-body text-base leading-relaxed text-zinc-600 mt-5 max-w-lg">
                Every program is built on a foundation of rigorous data, reproducible
                automation and a relentless focus on patients.
              </p>
            </Reveal>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-black/5 border border-black/5 mt-12 rounded-xl overflow-hidden">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={0.1 + i * 0.07} className="bg-white">
                  <div className="p-6">
                    <div className="font-heading text-3xl lg:text-4xl tracking-tight text-zinc-900">
                      {s.value}
                    </div>
                    <div className="font-mono text-[11px] tracking-wider uppercase text-zinc-500 mt-2">
                      {s.label}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* image */}
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-zinc-100 border border-black/5">
                <motion.img
                  style={{ y: imgY, scale }}
                  src="https://images.unsplash.com/photo-1614935151651-0bea6508db6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                  alt="Scientist working in a clean laboratory"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute bottom-5 left-5 backdrop-blur-xl bg-white/80 border border-black/5 rounded-xl px-5 py-3">
                  <div className="font-mono text-[11px] tracking-widest uppercase text-brand">
                    Est. 2019
                  </div>
                  <div className="font-heading text-sm text-zinc-900 mt-0.5">
                    Cambridge · Basel · Singapore
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
